import { useCallback, useMemo } from 'react';
import { Element } from '@thive/canvas';

import { useFloorplanDesignStore } from '@/modules/floorplanDesign/store/useFloorplanDesignStore';
import { AreaPickerServiceFactory } from '@/modules/canvas/services/AreaPicker/AreaPickerServiceFactory';

export const useChooseClick = () => {
  const areaPickerSvc = useMemo(
    () => AreaPickerServiceFactory.getInstance().createAreaPickerService(),
    [],
  );

  // Read the area on click instead of subscribing to the whole store, so this callback
  // (and the canvas event registration that depends on it) stays stable.
  const chooseClick = useCallback(
    (element: Element) => {
      const area = useFloorplanDesignStore.getState().getAreaById(element.id);
      if (area) {
        areaPickerSvc.complete(area.id);
        return;
      }

      const template = useFloorplanDesignStore.getState().getTemplateById(element.id);
      if (!template) return;

      areaPickerSvc.complete(template.group.id);
    },
    [areaPickerSvc],
  );

  return { chooseClick };
};
